import React, { useEffect, useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import Header from './Header';
import BodyOne from './BodyOne';
import BodyTwo from './BodyTwo';
import BodyThree from './BodyThree';
import FAQ from './FAQ';
import Footer from './Footer';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: 'linear-gradient(#ccd3eb, #fff8ef)',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px 50px 20px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '10px 30px 75px 30px',
    },
    [theme.breakpoints.up('lg')]: {
      // padding: '10px 165px 75px 165px',
    },
  },
  alertWrapper: {
    position: 'absolute',
    top: 0,
    zIndex: 20,
    left: '50%',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '-100px',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: '-200px',
    },
    [theme.breakpoints.up('lg')]: {
      marginLeft: '-300px',
    },
  },
  alert: {
    [theme.breakpoints.down('sm')]: {
      width: '200px',
    },
    [theme.breakpoints.up('md')]: {
      width: '400px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '600px',
    },
  },
  fixedFooter: {
    position: 'fixed',
    bottom: 0,
    zIndex: 1000000,
    padding: '8px',
    background: '#394F94',
    width: '100%',
    textAlign: 'center',
    color: 'white',
  },
  footerText: {
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
}));

const MailingSite = () => {
  const classes = useStyles();
  const [submitted, setSubmitted] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (submitted) {
      setOpen(true);
    }
    if (open) {
      setSubmitted(false);
    }
  }, [submitted, open]);

  return (
    <div>
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={false} sm={false} md={false} lg={false} xl={1} />
          <Grid item xs={12} sm={12} md={12} lg={12} xl={10}>
            {open && (
              <div className={classes.alertWrapper}>
                <Alert
                  severity="success"
                  onClose={() => setOpen(false)}
                  className={classes.alert}>
                  You've been added on the mailing list 🥰
                </Alert>
              </div>
            )}
            <Header />
            <BodyOne
              actions={{
                setSubmitted: (value) => setSubmitted(value),
                setOpen: (value) => setOpen(value),
              }}
            />
            <BodyTwo />
          </Grid>
          <Grid item xs={false} sm={false} md={false} lg={false} xl={1} />
        </Grid>
      </div>
      <motion.div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <BodyThree />
          </Grid>
        </Grid>
      </motion.div>
      <motion.div className={classes.root}>
        <Grid container>
          <Grid item xs={false} sm={false} md={false} lg={false} xl={1} />
          <Grid item xs={12} sm={12} md={12} lg={12} xl={10}>
            <FAQ />
            <Footer
              actions={{
                setSubmitted: (value) => setSubmitted(value),
                setOpen: (value) => setOpen(value),
              }}
            />
          </Grid>
          <Grid item xs={false} sm={false} md={false} lg={false} xl={1} />
        </Grid>
      </motion.div>
    </div>
  );
};

export default MailingSite;
